'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _route = require('./route.js');

var _route2 = _interopRequireDefault(_route);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MapifyMap = function () {
	function MapifyMap(mapifyMap) {
		(0, _classCallCheck3.default)(this, MapifyMap);

		this.$container = mapifyMap.$container;
		this.mapService = mapifyMap.mapService.map;
		this.routes = [];
		this.bounds = L.latLngBounds([]);

		for (var i = 0; i < mapifyMap.settings.routes.length; i++) {
			var routeSettings = mapifyMap.settings.routes[i];
			var route = new _route2.default(this, routeSettings);
			this.addRoute(route);
		}

		this.refresh();
	}

	(0, _createClass3.default)(MapifyMap, [{
		key: 'addRoute',
		value: function addRoute(route) {
			var _this = this;

			if (!route.settings.valid) {
				return;
			}

			this.routes.push(route);
			for (var i = 0; i < route.waypoints.length; i++) {
				var waypoint = route.waypoints[i];
				this.bounds.extend([parseFloat(waypoint.latlng[0]), parseFloat(waypoint.latlng[1])]);
			}

			route.createLayer().then(function (routeLayer) {
				return _this.mapService.addLayer(routeLayer);
			});
		}
	}, {
		key: 'fitBounds',
		value: function fitBounds() {
			// do nothing
		}
	}, {
		key: 'refresh',
		value: function refresh() {
			// do nothing
		}
	}]);
	return MapifyMap;
}();

exports.default = MapifyMap;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/mapify-map.js
// module id = 13
// module chunks = 0